module.exports = __webpack_public_path__ + "img/en-US.08055e46.svg";